import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/client';
import conectedLogo from '../assets/logo-conectedit.png';
import './LoginPage.css';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    try {
      const response = await apiClient.post('/auth/forgot-password', { email });
      setMessage(response.data.message);
    } catch {
      setMessage('No pudimos procesar la solicitud. Intentá nuevamente.');
    } finally {
      setBusy(false);
    }
  };

  return <div className="login-container"><div className="login-card"><div className="login-header"><div className="login-product-mark standalone-mark"><img src={conectedLogo} alt="ConectedIT Software Factory" /></div><span className="login-mobile-brand standalone-brand">Recibos Digitales</span><h1>Recuperar contraseña</h1><p>Te enviaremos un enlace seguro para crear una nueva.</p></div><form className="login-form" onSubmit={submit}>{message && <div className="success-message">{message}</div>}<div className="form-group"><label htmlFor="email">Correo electrónico</label><input id="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required disabled={busy} /></div><button className="login-button" disabled={busy}>{busy ? 'Enviando…' : 'Enviar instrucciones'}</button><Link className="login-link" to="/login">Volver al inicio de sesión</Link></form></div></div>;
};

export default ForgotPasswordPage;
